module.exports = __webpack_public_path__ + "static/media/18ECA39.915490f3.jpg";